import * as React from "react";
import { observer } from "mobx-react-lite";
import { entityCardStore as pageStore } from "./EntityCardStore";

export const EntityCardTitle: React.FC = observer(() =>
  pageStore.isDirty ? (
    <span>
      {pageStore.entityName} <sup style={{ color: "silver" }}>*</sup>
    </span>
  ) : (
    pageStore.entityName
  ),
);
